import React,{useState,useEffect} from 'react'
import CardBoxPogram from '../CardsBox/CardBoxProgram';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination,Mousewheel } from "swiper/modules";
import { fetchPromotions } from '../../services/promotion';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./SliderCardsChallenge.css"


const SliderCardsPrograms = () => {
    const [seriesList, setSeriesList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=>{
      getAllSeriesList();
    },[])

    const getAllSeriesList =  async () => { 
      try{     
          setIsLoading(true);
          const response = await fetchPromotions();
          const data = Array.isArray(response) ? response : [];
          setSeriesList(data)
      }catch(error){
          console.log(error);
      }finally{
          setIsLoading(false);
      }
    };

    const visiblePrograms = (seriesList || []).filter((item) => {
      if (!item?.active) return false;
      if (item?.serieId === 'RETOMA-ENCIENDE-ACTIVA' || item?.serieId === 'Reto-Estres-y-Ansiedad') {
        return false;
      }
      return Boolean(item?.serieId && item?.thumbnail);
    });

    if (!isLoading && visiblePrograms.length === 0) {
      return null;
    }

  return (
    <>
      <h2 className={`${visiblePrograms.length > 0 ? "" : "hidden"} uppercase text-center text-sb-800 font-[MADE-Bon-Voyage] p-10  text-4xl md:text-6xl`}>Programas</h2>
      <Swiper
        modules={[Pagination, Mousewheel]}
        slidesPerView={1}
        spaceBetween={16}
        centeredSlides={false}
        mousewheel={{ forceToAxis: true }}
        grabCursor
        pagination={{
          clickable: true,
        }}
        initialSlide={0}
        breakpoints={{
          480: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          980: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        }}
        className="mySwiper px-2 md:px-4"
      >
        {visiblePrograms.map((item) => (
            <SwiperSlide key={item.serieId} className="flex justify-center items-center py-2">
            <CardBoxPogram
              title=""
              desc=''
              imageUrl={item.thumbnail}
              url={`/promotion/${item.serieId}`}
              active={item.active}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default SliderCardsPrograms;